import React from "react";

import { Flex } from "antd";

import { ExperimentDetailsSection } from "../components/context/ExperimentDetailsSection";
import { useExperimentEditor } from "../hooks/useExperimentEditor";

export const ExperimentContextPage: React.FC = () => {
  const { experimentData, setExperimentData } = useExperimentEditor();

  return (
    <Flex vertical style={{ flex: 1 }}>
      <ExperimentDetailsSection
        experimentData={experimentData}
        setExperimentData={setExperimentData}
      />
    </Flex>
  );
};

export default ExperimentContextPage;
